module.exports = __webpack_public_path__ + "static/media/warning.2e7f87c7.svg";